import { render } from "./StaticticsIndex.vue?vue&type=template&id=1ba8276e"
import script from "./StaticticsIndex.vue?vue&type=script&lang=js"
export * from "./StaticticsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__